import { useRouter } from "next/router";
import { KeyboardEvent } from "react";
import { useCustomerAnalytics } from "../../../../services/hooks/useCustomerAnalytics";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { CUSTOMER_ANALYTICS_EVENT, PagesEnum } from "../../../../utils/enums";
import { getPageLink } from "../../../../utils/help/navigation/navigation";
import { PointsArrowIcon } from "../../../global/Icons/loyalty.icons";
import { WalletBalanceContent } from "../../../shared/Wallet/WalletBalanceContent/WalletBalanceContent";
import styles from "./WalletMenuBalance.module.scss";

/**
 * The Wallet tab of the menu's rewards card: the shared balance, with an arrow
 * into the Wallet page. The whole balance area is the way in (story: "tapping
 * the balance area itself takes the customer to the Wallet page"); the arrow
 * is its visual cue, not a separate control.
 */
export const WalletMenuBalance = () => {
  const router = useRouter();
  const { t } = useTranslationI18();
  const addCustomerAnalytics = useCustomerAnalytics();

  // Same as the Points tab's arrow to /rewards.
  const goToWallet = () => {
    addCustomerAnalytics(
      CUSTOMER_ANALYTICS_EVENT.WALLET_BALANCE_CONTAINER_CLICKED,
      {
        Screen: "menu",
      }
    );
    router.push(getPageLink(router, PagesEnum.Wallet).as);
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      goToWallet();
    }
  };

  return (
    <div
      className={styles.container}
      role="link"
      tabIndex={0}
      aria-label={t("wallet:open-wallet")}
      onClick={goToWallet}
      onKeyDown={onKeyDown}
      data-testid="wallet-menu-balance"
    >
      <WalletBalanceContent
        trailing={
          <span
            className={styles.arrow}
            aria-hidden="true"
            data-testid="wallet-arrow"
          >
            <PointsArrowIcon size={0.8928571429} />
          </span>
        }
      />
    </div>
  );
};
